import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import MainChargesPaidBy from './ChargesPaidByList'
import { useSelector } from 'react-redux'
import {
  allCrudNames,
  allPages,
  checkPageAccess
} from '../../../lib/AllPageNames'
import NotFound from '../../NotFound/NotFound'

const ChargesPaidByTabbing = () => {
  const [activeToggle, setActiveToggle] = useState('chargesPaidBy')
  const { pageAccess } = useSelector((state) => state.user)

  const handleTabClick = (e, tabName) => {
    e.preventDefault()
    setActiveToggle(tabName)
  }
  return checkPageAccess(
    pageAccess,
    allPages?.manageChargesPaidBy,
    allCrudNames?.read
  ) ? (
    <>
      {checkPageAccess(
        pageAccess,
        allPages?.manageChargesPaidBy,
        allCrudNames?.read
      ) && (
        <div className='card overflow-hidden'>
          <div className='card-body p-0'>
            <div className='nav-tabs-horizontal nav nav-tabs'>
              <Link
                // onClick={() => setActiveToggle('chargesPaidBy')}
                onClick={(e) => handleTabClick(e, 'chargesPaidBy')}
                data-toggle='tab'
                className={`nav-link fw-semibold ${
                  activeToggle === 'chargesPaidBy' ? 'active show' : ''
                }`}
              >
                <span className='nav-span'>
                  Charges Paid By
                  <hr />
                </span>
              </Link>
            </div>

            <div className='tab-content p-3'>
              <div
                id='chargesPaidBy'
                className={`tab-pane fade ${
                  activeToggle === 'chargesPaidBy' ? 'active show' : ''
                }`}
              >
                {activeToggle === 'chargesPaidBy' && <MainChargesPaidBy />}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  ) : (
    <NotFound />
  )
}

export default ChargesPaidByTabbing
